/**
 * 微信支付
 * 2020/10/17
 * */

import utils from "../../jslib/utils"
import uihelper from './../../jslib/UIHelper'

export default {

  redirectUri: location.href,
  result: undefined,           // 订单信息

  paySuccess: ()=>{},
  payFailed: undefined,

  /**
   * 单页面应用时 ios 获取微信签名域名为首次进入的URL，重定向以更新域名
   * @param times {number} 最多重定向多少次
   * */
  relocation(times = 1){

    return new Promise((resolve, reject)=>{
      let refresh_times = ~~utils.getQueryString('refresh_times') + 1
      let {ios, weChat} = utils.getPlatform()

      console.log('needRelocation', ios && weChat && refresh_times <= times)
      if(ios && weChat && refresh_times <= times){
        location.href = utils.updateUrlQS(location.href, 'refresh_times', refresh_times)
      }else{
        resolve()
      }
    })

  },

  // 获取微信Code码
  async getWxCode(redirectUri = location.href){
    await this.relocation()
    let code = utils.getQueryString('code')
    this.redirectUri = redirectUri

    // 没有code参数，先触发微信返回code码
    console.log('微信支付code', code || sessionStorage.wx_code)

    if( !code && !sessionStorage.wx_code ){
      this.refreshCode()
    } else {
      if(code){
        sessionStorage.wx_code = code
        sessionStorage.get_wx_code_refresh = 1
        history.back()
      }else{
        if(sessionStorage.get_wx_code_refresh){
          sessionStorage.removeItem('get_wx_code_refresh')
          try{
            this.$router && this.$router.go && this.$router.go(0)
          }catch (e){
            console.log(e)
            history.go(0)
          }
        }
      }
    }

    return sessionStorage.wx_code
  },

  checkCode(){
    if(['', undefined, null].includes(sessionStorage.wx_code)){
      uihelper.toast('微信授权失败')
      this.refreshCode()
      return false
    }
    return true
  },

  arouseWechatPay(){
    console.log('WeixinJSBridge_1', WeixinJSBridge)
    if (typeof WeixinJSBridge == "undefined"){
      if( document.addEventListener ){
        document.addEventListener('WeixinJSBridgeReady', ()=>{this.jsApiCall()}, false)
      }else if (document.attachEvent){
        document.attachEvent('WeixinJSBridgeReady', ()=>{this.jsApiCall()})
        document.attachEvent('onWeixinJSBridgeReady', ()=>{this.jsApiCall()})
      }
    }else{
      this.jsApiCall()
    }
  },

  jsApiCall()  {

    console.log('arousePayParam_0', this.result, WeixinJSBridge.invoke)

    let {appId, timeStamp, nonceStr, /*package,*/ signType, paySign} = this.result

    // 调起微信支付
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      // this.result,
      {
        'appId': appId,
        'timeStamp': timeStamp,
        'nonceStr': nonceStr,
        'package': this.result.package,
        'signType': signType,
        'paySign': paySign,
      },
      res => {
        switch (res.err_msg){
          case 'get_brand_wcpay_request:ok':                // 支付成功
            uihelper.toast('支付成功')
            setTimeout(()=>{
              this.paySuccess()                             // 支付成功后跳转
            }, 500)
            break;
          case 'get_brand_wcpay_request:cancel':            // 支付取消
          case 'get_brand_wcpay_request:fail':              // 支付失败
            uihelper.toast('支付失败')

            if(this.payFailed){
              this.payFailed()                              // 支付失败后跳转
            }else{
              this.refreshCode()                            // 重新刷新页面获取新的Code
            }

            break
          default:
        }
        WeixinJSBridge.log(res.err_msg)
        console.log('微信支付提示', res.err_code+' '+res.err_desc+' '+res.err_msg)
      }
    )

  },

  // 重新获取code
  refreshCode() {

    console.log('跳转至微信授权页')

    let appid = 'wxcbc0875a017d85e2'

    location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize'
      + '?appid=' + appid
      + '&redirect_uri=' + encodeURIComponent(utils.delUrlQS(this.redirectUri, 'code'))
      + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'

  },

  // 清除wx_code
  clearWxCode(){
    sessionStorage.removeItem('wx_code')
  },
}
